export default {
  mainApps: {
    shenyue: {
      themeColor: '#1890ff',
      baseURL: 'https://devpplatform-api.jilingshu.com.cn',
      apiPrefix: '/backend/resource'
    },
    teacherPlatform: {
      themeColor: '#1ec38f',
      baseURL: 'https://devpuser-api.jilingshu.com.cn/',
      apiPrefix: '/teacher/resource'
    },
    schoolPlatform: {
      themeColor: '#1ec38f',
      baseURL: 'https://devpuser-api.jilingshu.com.cn/',
      apiPrefix: '/teacher/resource'
    },
    institutionPlatform: {
      themeColor: '#1890ff',
      baseURL: 'https://devpresource-center.jilingshu.com.cn',
      apiPrefix: ''
    },
    // 通用服务接口调用相关配置
    commonService: {
      baseURL: 'https://devpgateway.jilingshu.com.cn',
      apiPrefix: '/api/common-service'
    },
    questionsBank: {
      baseURL: 'https://devpexam-center-service.jilingshu.com.cn',
      apiPrefix: ''
    }
  },
  serverURL: 'https://devpresource.jilingshu.com.cn',
  resourceApiDomain: 'https://devpresource-center.jilingshu.com.cn',
  pptist: {
    name: 'pptist',
    entry: 'https://devpppt.jilingshu.com.cn'
    // entry: 'http://localhost:8090'
  },
  knowledgePoint: {
    name: 'knowledgePoint',
    entry: 'https://devpppt.jilingshu.com.cn'
  },
  musicScore: 'https://devpmusic-score.jilingshu.com.cn'
  // musicScore: 'http://localhost:8081'
}
